




import { Component, Mixins } from "vue-property-decorator";
import {
  PatientSpecifiedHeaderPane,
} from "../../../panes";
import { EmbeddedEditMenuContainer } from "../contents";
import { PaneMixin } from "./mixins";

@Component({
  components: {
    PatientSpecifiedHeaderPane,
    EmbeddedEditMenuContainer,
  }
})
export default class HeaderPane extends Mixins(PaneMixin) {
  get key(): string {
    return this.isEmbedded
      ? "EmbeddedEditMenuContainer"
      : "PatientSpecifiedHeaderPane";
  }
}
